import { render, staticRenderFns } from "./EditNotification.vue?vue&type=template&id=5f00ddbd&scoped=true"
import script from "./EditNotification.vue?vue&type=script&lang=js"
export * from "./EditNotification.vue?vue&type=script&lang=js"
import style0 from "./EditNotification.vue?vue&type=style&index=0&id=5f00ddbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f00ddbd",
  null
  
)

export default component.exports